import { Injectable } from '@angular/core';
// import { Http, HttpModule, Headers } from '@angular/http';
import { ParEmployee } from '../../model/par_employees.model';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import { Subject } from 'rxjs/Subject';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject } from 'rxjs';
import { error, $ } from 'protractor';
import { ObservableMedia } from '@angular/flex-layout';
import { Observable } from 'rxjs/Observable';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()

export class ManageUsersService {
  load;
  
  url = environment.configURI;
  private getAllSiteAdminData = '/getusers';
  private deleteSiteAdminUser = '/deleteuser/';

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  // add Par employee
  addSiteAdmin(addAdminUser) {
     return this.httpClient.post(this.url + '/adduser/', addAdminUser)
       .catch(this.userFriendlyMsgs.errorHandler);
   }

   getAllSiteAdminUser() {
    return this.httpClient.get(`${this.url}${this.getAllSiteAdminData}`)
      .catch(this.userFriendlyMsgs.errorHandler);
  }

   getRoles() {
    return this.httpClient.get(environment.Roles)
      .catch(this.userFriendlyMsgs.errorHandler);
  }

  deleteSiteAdmin(Id) {
    return this.httpClient.delete(this.url + '/deleteuser/' + Id).catch(this.userFriendlyMsgs.errorHandler);
  }

  editSiteAdmin(data) {
    const body = {
      first_name: data.first_name,
      last_name: data.last_name,
      role: data.role,
      blocked_user: data.blocked_user,
    //  isActive: data.isActive,
      updated_by : localStorage.getItem('loginID'),
    };
    return this.httpClient.put(this.url + '/edituser/' + data.docId, body)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/manage-users/manage-users.service.ts